import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import validationEN from './locales/en/validation.json';
import validationFR from './locales/fr/validation.json';

const resources = {
    en: {
        translation: translationEN,
        validation: validationEN
    },
    fr: {
        translation: translationFR,
        validation: validationFR
    }
};

i18n
    .use(initReactI18next)
    .init({
        resources,
        lng: 'en', // default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // react already safe from xss
        }
    });

export default i18n;
